import { ref, reactive, computed, watch } from "vue";
import { defineStore } from "pinia";

export const useServiceStore = defineStore("sert", () => {
	const screens = {
		authPhone: "authPhone",
		authSms: "authSms",
		authUserData: "authUserData",
		services: "services",
		rentalInventory: "rentalInventory",
		rentalCourt: "rentalCourt",
		selectDate: "selectDate",
		bookings: "bookings",
		success: "success",
		error: "error",
	};
	const isClient = typeof window !== "undefined";
    const normalizeHash = () => {
        if (!isClient) return screens.authPhone;

        const hash = window.location.hash.slice(1);

        if (Object.keys(screens).includes(hash)) {
            return hash;
        }

        window.location.hash = screens.authPhone;
        return screens.authPhone;
    };

	const currentScreen = ref(normalizeHash());
	const isScreenLoading = ref(true);

	const goToScreen = (nameScreen) => {
		isScreenLoading.value = true;
		currentScreen.value = nameScreen;
	};

	const hideScreenLoader = () => {
		isScreenLoading.value = false;
	};

	const timerActive = ref(true);
	const remainingTime = ref({
		minutes: "00",
		secundes: "00",
	});
	let intervalId;
	const timer = () => {
				
		let totalSeconds = 60;
		timerActive.value = true
		intervalId = setInterval(() => {
			const minutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;

			remainingTime.value.minutes = String(minutes).padStart(2, "0");
			remainingTime.value.secundes = String(seconds).padStart(2, "0");

			if (totalSeconds <= 0) {
				clearInterval(intervalId);
				timerActive.value = false;
			} else {
				totalSeconds--; // уменьшаем секунды
			}
		}, 1000);
	};

	const resetTimer = () => {
		clearInterval(intervalId);
		timerActive.value = true;
	};

	const selectedCourt = ref({});
	const courtTimes = ref([]);
	if(isClient) {
		selectedCourt.value = JSON.parse(sessionStorage.getItem("selectedCourt")) || {};
		courtTimes.value = JSON.parse(sessionStorage.getItem("courtTimes")) || [];
	}

	const addCourtTime = (rentalType = "court", rentalAt, price, crmId, title = "", desc = "") => {
		const index = courtTimes.value?.findIndex((item) => item.rental_at === rentalAt);

		if (index !== -1) {
			courtTimes.value?.splice(index, 1);
		} else {
			courtTimes.value?.push({
				type: rentalType,
				quantity: 1,
				rental_at: rentalAt,
				crm_id: crmId,
				price: price,
				title: title,
				desc: desc,
			});
		}
		sessionStorage.setItem("courtTimes", JSON.stringify(courtTimes.value));
	};

	const addCheckedCourt = (courtPrice, courtTitle, courtImage) => {
		selectedCourt.value = {
			title: courtTitle,
			price: courtPrice,
			image: courtImage,
		};
		sessionStorage.setItem("selectedCourt", JSON.stringify(selectedCourt.value));
	};

	const clearSessionSelectedCourt = () => {
		sessionStorage.removeItem("selectedCourt");
		selectedCourt.value = {};
	};

	const clearSessionCourtTimes = () => {
		sessionStorage.removeItem("courtTimes");
		courtTimes.value = [];
	};

	return {
		goToScreen,
		timer,
		resetTimer,
		addCourtTime,
		addCheckedCourt,
		clearSessionSelectedCourt,
		clearSessionCourtTimes,
		hideScreenLoader,

		currentScreen,
		screens,
		remainingTime,
		timerActive,
		courtTimes,
		selectedCourt,
	};
});
